module.exports = __webpack_public_path__ + "img/6_74.fcb551ca.png";